module.exports = __webpack_public_path__ + "img/nu.1d6bf146.svg";